import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../components/AppContent.css';

export const DashboardLayout: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/login');
  };

  return (
    <div className={`app-content ${theme.isDark ? 'dark' : 'light'}`}>
      <Sidebar theme={theme} onMenuItemClick={() => {}} />

      <div className={`app-header ${theme.isDark ? 'dark' : 'light'}`}>
        <h1 className={`app-title ${theme.isDark ? 'dark' : 'light'}`}>
          {t('sidebar.title')}
        </h1>
        <div className="user-info">
          <button
            className={`theme-button ${theme.isDark ? 'dark' : 'light'}`}
            onClick={toggleTheme}
          >
            {theme.isDark ? '☀️' : '🌙'}
          </button>
          <button
            className={`theme-button ${theme.isDark ? 'dark' : 'light'}`}
            onClick={() =>
              setLanguage(
                language === 'ru' ? 'ky' : language === 'ky' ? 'en' : 'ru'
              )
            }
          >
            {language === 'ru' ? 'КЫР' : language === 'ky' ? 'ENG' : 'РУС'}
          </button>

          <div className="header-divider"></div>

          <div className={`user-badge ${theme.isDark ? 'dark' : 'light'}`}>
            <div className={`user-avatar ${theme.isDark ? 'dark' : 'light'}`}>
              👤
            </div>
            <div className="user-details">
              <div className="user-login">admin</div>
              <div className="user-role">{t('role.admin')}</div>
            </div>
          </div>

          <div className="header-divider"></div>

          <button className="logout-button" onClick={handleLogout}>
            <span>🚪</span>
            <span>{t('header.logout')}</span>
          </button>
        </div>
      </div>

      <div className={`app-main ${theme.isDark ? 'dark' : 'light'}`}>
        <Outlet />
      </div>
    </div>
  );
};
